// Number formatting shared by the free-tool controllers. Everything the
// calculators show passes through here so a margin, a price and a count read
// the same way on every page.

const locale = "en-US"

export function money(value, digits = 0) {
  if (!Number.isFinite(value)) return "—"
  return new Intl.NumberFormat(locale, {
    style: "currency", currency: "USD",
    minimumFractionDigits: digits, maximumFractionDigits: digits
  }).format(value)
}

export function percent(value, digits = 1) {
  if (!Number.isFinite(value)) return "—"
  return `${(value * 100).toFixed(digits)}%`
}

export function number(value, digits = 0) {
  if (!Number.isFinite(value)) return "—"
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: digits, maximumFractionDigits: digits
  }).format(value)
}

// The numeric value of a field, or 0 when it is blank or not a number.
export function read(input) {
  const value = parseFloat(String(input.value).replace(/,/g, ""))
  return Number.isFinite(value) ? value : 0
}

// Fills the %{name} placeholders of a translated message. The strings come
// from the page (a Stimulus `messages` value), so the copy stays editable
// in the CMS like everything else.
export function fill(template, values = {}) {
  return String(template ?? "").replace(/%\{(\w+)\}/g, (_, key) => (key in values ? values[key] : `%{${key}}`))
}

// Copies text and briefly relabels the button that asked for it.
export async function copyText(text, button, messages = {}) {
  try {
    await navigator.clipboard.writeText(text)
    flash(button, messages.copied || "Copied")
  } catch {
    flash(button, messages.copy_failed || "Copy failed")
  }
}

function flash(button, label) {
  if (!button) return
  const original = button.dataset.label || button.textContent
  button.dataset.label = original
  button.textContent = label
  clearTimeout(button._flash)
  button._flash = setTimeout(() => { button.textContent = original }, 1400)
}
